export enum FilterModelNames {
  UnitType = 'unit_type',
  UnitUuid = 'unit_account_uuid',
  RefmodelUuid = 'reference_model_uuid',
  DrillPileStatus = 'DrillPileStatus',
  Id = '_id',
  APLNoSync = 'APLNoSync',
  DiscardedPoints = 'include_discarded'
}